const definePricingMap = (props, video) => {
  const isSubscribed = props.user && props.user.isSubscribed
  const hasPurchased = !!video.purchaseStatus
  const pricingType = ((props.pricingOptions && props.pricingOptions.type) || 
  (video.pricing && video.pricing.type)) || window.settings.serviceType
  const pricingMap = {
    'FREE': true,
    'AVOD': true,
    'TVOD': hasPurchased, // include rents when available, if rent && rentalPeriod > Date.now()
    'SVOD': isSubscribed,
    'PPV': hasPurchased,
    'SVOD+TVOD': hasPurchased || isSubscribed,
    'SVOD+PPV': hasPurchased || isSubscribed
  }
  return pricingMap[pricingType]
}

export default definePricingMap



